





























import Vue from 'vue'

import { Component, Prop, Watch } from 'vue-property-decorator'
import { required } from '@/utils/formValidations'
import {
  greaterOrEquals,
  lessOrEquals,
  maxLength,
  totalLength,
} from '@/utils/ValidationUtil'
import { KEYS_TIPO_DIAS_SEMANA } from '@/api/StaticApi'

@Component({
  components: {},
})
export default class FrecuenciaNotificaciones extends Vue {
  $refs: {
    form: Vue & { validate(): boolean; resetValidation(): void; reset(): void }
  }

  @Prop({ default: false, type: Boolean })
  private disabled: boolean

  @Prop({ required: true })
  private value!: KEYS_TIPO_DIAS_SEMANA[]

  @Prop({ default: false, type: Boolean })
  private loading = false

  @Prop({ default: false, type: Boolean })
  private error = false

  private localInstance: KEYS_TIPO_DIAS_SEMANA[] = this.value

  private formDisabled = false

  private autoGrow = false

  private dialog = false

  private valid = true

  private rules = {
    required,
    maxLength500: maxLength(500),
    length4: totalLength(4),
    greaterOrEquals2021: greaterOrEquals((): number => 2021),
    maxLength6: maxLength(6),
    lessOrEquals: lessOrEquals(this.calcularMax.bind(this)),
  }
  calcularMax(): number | undefined {
    return new Date().getUTCFullYear()
  }
  private show = true
  private get lunes() {
    return this.findDays('LUNES')
  }

  private set lunes(value) {
    this.modifyDays(value, 'LUNES')
  }
  private get martes() {
    return this.findDays('MARTES')
  }

  private set martes(value) {
    this.modifyDays(value, 'MARTES')
  }
  private get miercoles() {
    return this.findDays('MIERCOLES')
  }

  private set miercoles(value) {
    this.modifyDays(value, 'MIERCOLES')
  }
  private get jueves() {
    return this.findDays('JUEVES')
  }

  private set jueves(value) {
    this.modifyDays(value, 'JUEVES')
  }
  private get viernes() {
    return this.findDays('VIERNES')
  }

  private set viernes(value) {
    this.modifyDays(value, 'VIERNES')
  }
  private modifyDays(value, day) {
    value ? this.localInstance.push(day) : this.deleteDay(day)
    this.$emit('input', this.localInstance)
  }

  private deleteDay(unDia) {
    this.localInstance = this.localInstance.filter((option) => option !== unDia)
  }
  private findDays(unDia: string) {
    return this.localInstance.find((dia) => dia === unDia)
  }

  resetValidation() {
    this.$refs.form.resetValidation()
  }
  reset() {
    this.$refs.form.reset()
  }

  validate() {
    return this.$refs.form.validate()
  }

  @Watch('value')
  private onEntidadChange() {
    if (this.value) {
      this.localInstance = JSON.parse(JSON.stringify(this.value))
    }
  }
}
